import { AbugidaThaiIcon } from './AbugidaThaiIcon';

/**
 * author: Haley Halcyon
 * id F782C16A-0558-4347-AB62-3E4A8DD299AD
 * name abugida-thai
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abugida-thai.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemThaiIcon = AbugidaThaiIcon;
export default WritingSystemThaiIcon